import React, { Component } from 'react'
import { connect } from 'react-redux'

const notFoundPageContainer = (ComposedComponent) => {
    class NotFoundPageContainer extends Component {
        render () {
            return (
                <ComposedComponent {...this.props} />
            )
        }
    }
    const mapStateToProps = ({
        langs: { indexLang },
    }) => ({
        indexLang,
    })
    return connect(mapStateToProps)(NotFoundPageContainer)
}

export default notFoundPageContainer
